import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ClientAuthCtx = createContext(null);

export function ClientAuthProvider({ children }) {
  const [client, setClient] = useState(null); // null = checking, false = anon, obj = logged in
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // If we're returning from Google Auth, let AuthCallback handle it
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setClient(data);
      } catch {
        setClient(false); // not authenticated — expected for anonymous visitors
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/client/login", { email, password });
    setClient(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/client/register", payload);
    setClient(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (error) {
      console.error("Logout request failed:", error);
    }
    setClient(false);
  };

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setClient(data);
    } catch (error) {
      console.error("Session refresh failed:", error);
    }
  };

  return (
    <ClientAuthCtx.Provider value={{ client, loading, login, register, logout, refresh, setClient }}>
      {children}
    </ClientAuthCtx.Provider>
  );
}

export function useClientAuth() {
  return useContext(ClientAuthCtx);
}
